/* Legibility for the "Nobody looks at the slope anymore" photo block.
   The subtitle is light grey over a busy photo (white snow, dark jackets),
   so it vanished in places. Keeps the photo and layout; adds a soft dark
   scrim behind the copy, brings the subtitle to full white and gives both
   lines a shadow so they hold on any part of the image. */
(function(){
var PHRASE='NOBODY LOOKS AT THE SLOPE';
function find(){
var all=document.body?document.body.getElementsByTagName('*'):[];
for(var i=0;i<all.length;i++){
var el=all[i];
if(el.tagName==='SCRIPT'||el.tagName==='STYLE')continue;
if((el.textContent||'').toUpperCase().indexOf(PHRASE)<0)continue;
var deeper=false;
for(var c=0;c<el.children.length;c++){if((el.children[c].textContent||'').toUpperCase().indexOf(PHRASE)>-1){deeper=true;break;}}
if(!deeper)return el;
}
return null;
}
function fix(){
var h=find();
if(!h)return false;
var box=h.parentNode;
if(!box||box.getAttribute('data-if-legible'))return true;
box.setAttribute('data-if-legible','1');
var cs=getComputedStyle(box);
if(cs.position==='static')box.style.position='relative';
box.style.isolation='isolate';
var scrim=document.createElement('div');
scrim.setAttribute('aria-hidden','true');
scrim.setAttribute('style','position:absolute; left:50%; top:50%; transform:translate(-50%,-50%); width:calc(100% + 40px); height:calc(100% + 36px); z-index:-1; pointer-events:none; border-radius:18px; background:radial-gradient(ellipse at center, rgba(12,15,19,0.72) 0%, rgba(12,15,19,0.55) 55%, rgba(12,15,19,0) 100%);');
box.insertBefore(scrim,box.firstChild);
h.style.textShadow='0 2px 14px rgba(0,0,0,0.65)';
var kids=box.children;
for(var i=0;i<kids.length;i++){
var k=kids[i];
if(k===h||k===scrim)continue;
if((k.textContent||'').trim().length<8)continue;
k.style.color='#FFFFFF';
k.style.opacity='1';
k.style.fontWeight='600';
k.style.textShadow='0 1px 3px rgba(0,0,0,0.85), 0 2px 12px rgba(0,0,0,0.6)';
}
return true;
}
var n=0;
var iv=setInterval(function(){n++;if(fix()||n>60)clearInterval(iv);},250);
if(document.readyState!=='loading')fix();else document.addEventListener('DOMContentLoaded',fix);
})();
